module.exports = __webpack_public_path__ + "static/policylink-5b97ed0881dd7824fd04f468dba24c09.png";